import {InvoiceStatusTypes} from "../../provider/ProviderManageInvoices/consts";

export const ChangeableInvoiceStatuses = [
    InvoiceStatusTypes.PENDING,
    InvoiceStatusTypes.ACCEPTED,
    InvoiceStatusTypes.DECLINED
];
